import { makeStyles, createStyles } from '@material-ui/core/styles';

import { theme, variables } from '@styles';

/**
 * LibraryPanel component styles
 * @returns {Function}
 */

export const useStyles = makeStyles(() =>
  createStyles({
    libraryPanel: {
      // position: 'relative',
      backgroundColor: 'transparent',
      borderRadius: '2rem',
      // flex: '0 0 auto',
      // paddingBottom: '1.6rem',

      // '&:before': {
      //   content: '""',
      //   position: 'absolute',
      //   zIndex: 0,
      //   width: '100%',
      //   height: variables.borderWidth.md,
      //   background: variables.color.primary.lightGray,
      //   left: 0,
      //   bottom: 0,
      // },

      '& .MuiToggleButtonGroup-root': {
        display: 'flex',
      },
    },

    library: {
      cursor: 'pointer',
      height: '11rem',
      width: '11rem',
      borderBottom: `${variables.borderWidth.md} solid ${variables.color.primary.lightGray}`,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      fontSize: variables.font.size.xs,

      '&:hover': {
        backgroundColor: variables.color.primary.backgroundLightGray,
      },
    },

    libraryName: {
      color: variables.color.primary.darkestGray,
    },

    // tabs: {
    //   display: 'inline-flex',
    //   minHeight: 'unset',
    // },

    // tab: {
    //   minHeight: 'unset',
    //   textTransform: 'none',
    //   fontSize: variables.font.size.xs,
    //   fontWeight: variables.font.weight.medium,
    //   lineHeight: variables.lineHeight.md,
    //   color: variables.color.primary.mediumGray,
    //   borderRight: `${variables.borderWidth.md} solid ${variables.color.primary.lightGray}`,
    //   padding: '11px 10px',
    // },

    tab: {
      '&&': {
        backgroundColor: variables.colorV2.button.tab.background.default,
        border: `solid 2px ${variables.colorV2.button.tab.border.default} !important`,
        // borderTopLeftRadius: '2rem !important',
        // borderTopRightRadius: '2rem !important',
        color: variables.colorV2.button.tab.text.default,
        fontSize: '1.3rem', // variables.font.size.md,
        fontWeight: 400, //variables.font.weight.bold,
        lineHeight: '3rem', // variables.lineHeight.lg,
        padding: '0 0',
        position: 'relative',
        textTransform: 'capitalize',
        width: '50%',

        ['@media (max-width: 1580px)']: {
          padding: '0 10px',
          width: 'auto',
        },

        '&.MuiToggleButtonGroup-groupedHorizontal:not(:first-child)': {
          // borderLeft: `1px solid ${variables.colorV2.button.tab.border.separator}`,
          marginLeft: 0,
        },

        '&.MuiToggleButtonGroup-groupedHorizontal:first-child': {
          // borderLeft: `1px solid ${variables.colorV2.button.tab.border.separator}`,
          borderTopLeftRadius: '2rem !important',
          marginLeft: 0,

          ['@media (max-width: 1580px)']: {
            padding: '0 10px',
            width: '40%',
          },
        },

        '&.MuiToggleButtonGroup-groupedHorizontal:last-child': {
          // borderLeft: `1px solid ${variables.colorV2.button.tab.border.separator}`,
          borderTopRightRadius: '2rem !important',
          marginLeft: 0,

          ['@media (max-width: 1580px)']: {
            padding: '0 10px',
            width: '60%',
          },
        },

        '&:hover': {
          backgroundColor: variables.colorV2.button.tab.background.hover,
          borderColor: variables.colorV2.button.tab.border.hover,
          color: variables.colorV2.button.tab.text.hover,
        },

        '&[data-left-tab]': {
          // borderTopLeftRadius: '2rem',
          borderTopRightRadius: 0,
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0,
        },

        '&[data-right-tab]': {
          borderTopLeftRadius: 0,
          // borderTopRightRadius: '2rem',
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0,
          // borderRight: `1px solid ${variables.colorV2.button.tab.border.default}`,
          // borderTop: `1px solid ${variables.colorV2.button.tab.border.default}`,
        },

        '&.Mui-selected': {
          backgroundColor: variables.colorV2.button.tab.background.active,
          border: `1px solid ${variables.colorV2.button.tab.border.active} !important`,
          // borderColor: variables.colorV2.button.tab.border.active,
          color: variables.colorV2.button.tab.text.active,
        },

        '&.Mui-selected:hover': {
          backgroundColor: variables.colorV2.button.tab.background.hoverActive,
          borderColor: variables.colorV2.button.tab.background.active,
          color: variables.colorV2.button.tab.text.hoverActive,
        },
      },
    },

    selectedTab: {
      overflow: 'visible',
      background: variables.color.primary.white,
      textTransform: 'none',
    },

    tabWrapper: {
      flexDirection: 'row',

      '&&': {
        '& > *:first-child': {
          marginRight: theme.spacing(1),
          marginBottom: '0',
        },
      },
    },
  }),
);
